import { StartUrl } from 'constants/RouteUrls'
import Button from 'core/components/buttons/Button'
import CardPageWrapper from 'core/components/page-wrapper/CardPageWrapper'
import useNavigation from 'core/hooks/navigation/useNavigation'
import useBlueBackground from 'pages/sign-up/useBlueBackground'
import { useMemo } from 'react'
import { CompanyType } from 'types/misc'
import useSLT from 'core/hooks/auth/useSLT'

const IncorrectAppPage = ({ company }: { company: CompanyType }) => {
  useBlueBackground()
  const {
    push,
    state: { userId, authToken }
  } = useNavigation()
  const classicDashboardUrl = import.meta.env.VITE_APP_CLASSIC_DASHBOARD_URL
  const motusUrl = import.meta.env.VITE_APP_MOTUS_URL

  const { getSLT, isLoading } = useSLT({
    onSuccess: (slt) => {
      window.location.replace(
        classicDashboardUrl.addUrlParams({
          slt
        })
      )
    },
    onError: () => {
      window.location.replace(classicDashboardUrl)
    }
  })

  const isMotus = company === 'motus'

  const title = useMemo(() => {
    if (isMotus) return 'Use the User Portal'
    return 'Use Everlance Sign In'
  }, [isMotus])

  const description = useMemo(
    () => (
      <>
        <p>
          Sorry! We cannot sign you in to this version. Please, use{' '}
          {isMotus ? 'the Classic version' : <b>Everlance</b>} to track your
          mileage until further notice.
        </p>
        <p>
          {isMotus
            ? 'You can go to the Classic version with the button below.'
            : 'You can go to the dashboard with the button below.'}
        </p>
      </>
    ),
    [isMotus]
  )

  const actionButton = useMemo(() => {
    return (
      <Button
        variant="primary"
        className="h-12"
        status={isMotus ? 'idle' : isLoading ? 'loading' : 'idle'}
        onClick={() => {
          if (isMotus) {
            window.location.href = motusUrl
            return
          }

          if (userId && authToken) {
            return getSLT({ userId, authToken })
          }

          if (!isMotus && !userId) {
            window.location.replace(classicDashboardUrl)
          }
        }}
      >
        Go to {isMotus ? 'User Portal' : 'Everlance'}
      </Button>
    )
  }, [
    classicDashboardUrl,
    getSLT,
    isLoading,
    isMotus,
    motusUrl,
    userId,
    authToken
  ])

  return (
    <CardPageWrapper
      backUrl={StartUrl}
      company="motus"
      dataTitle="incorrect-app-screen"
      wrapperClassName="flex flex-col gap-4"
    >
      <h3 className="text-4xl text-primary font-bold">{title}</h3>
      <div className="text-lg flex flex-col gap-4">{description}</div>
      {actionButton}
      <Button variant="outline" className="h-12" onClick={() => push(StartUrl)}>
        Back to Sign In
      </Button>
    </CardPageWrapper>
  )
}

export default IncorrectAppPage
